enum PRICE_FORMAT {
  EURO = 'euro',
  EURO_SPACE = 'euro-sp',
  POINTS = 'points',
  PERCENTAGE = 'pourcentage',
}

export default PRICE_FORMAT;
